import React, { FunctionComponent, useContext } from 'react';
import { CommunityApp, NewsletterSignup } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';

import { UserContext } from 'src/context/UserContext';
import { getAnalyticsAnonymousId } from 'src/utils/initializeFeatureGates';
import { getEnvironment } from 'src/services/http/user';
import { sendTrackEvent, sendUIEvent } from 'src/utils/analytics';

const onNewsletterSignupClick = async (app: CommunityApp, atlassianId?: string): Promise<void> => {
  await sendUIEvent(`${app}Newsletter`, 'button', 'clicked', 'communityNewsletterSignup', {}, atlassianId);
};

const onNewsletterSignupSuccess = async (app: CommunityApp, atlassianId?: string): Promise<void> => {
  await sendTrackEvent(`${app}Newsletter`, 'userCommunityNewsletterSignup', 'succeeded', {}, atlassianId);
};

const onNewsletterSignupError = async (app: CommunityApp, atlassianId?: string): Promise<void> => {
  await sendTrackEvent(`${app}Newsletter`, 'userCommunityNewsletterSignup', 'failed', {}, atlassianId);
};

type NewsletterProps = {
  app: CommunityApp;
};

export const EmailSubscription: FunctionComponent<NewsletterProps> = ({ app }) => {
  const data = useContext(UserContext);
  const user = data?.user;

  const anonymousId = getAnalyticsAnonymousId();
  const atlassianId = user?.account_id;

  return (
    <div id="subscribe" css={containerStyles} data-testid="email-subscription-section">
      <NewsletterSignup
        anonymousId={anonymousId}
        atlassianId={atlassianId}
        environment={getEnvironment()}
        eventHandlers={{
          onSubmit: onNewsletterSignupClick.bind(null, app, atlassianId),
          onSuccess: onNewsletterSignupSuccess.bind(null, app, atlassianId),
          onError: onNewsletterSignupError.bind(null, app, atlassianId),
        }}
      />
    </div>
  );
};

const containerStyles = css({
  width: '100%',
  padding: `0 ${token('space.200')}`,
  marginTop: '104px',

  [media.below.md]: {
    marginTop: token('space.800'),
  },

  [media.below.sm]: {
    marginTop: token('space.600'),
  },
});
